import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

const styles = () => ({
    buttonsContainer: {
        display: 'flex',
        marginLeft: 10
    }
});

const TablePaginationActions = props => {
    const { count, page, rowsPerPage, onPageChange, classes } = props;

    const lastPageNumber = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    const isLastPage = page >= Math.ceil(count / rowsPerPage) - 1;

    const handleFirstPageButtonClick = event => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = event => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onPageChange(event, lastPageNumber);
    };

    return (
        <div className={classes.buttonsContainer}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
                size="large"
            >
                <FirstPageIcon />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
                size="large"
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={isLastPage}
                aria-label="next page"
                size="large"
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={isLastPage}
                aria-label="last page"
                size="large"
            >
                <LastPageIcon />
            </IconButton>
        </div>
    );
};

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};

export default withStyles(styles)(TablePaginationActions);
